import { Box, Typography } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import React, { useContext } from 'react';
import { ProductPageContext } from './ProductPageContext';
import PageProductDetailCommerceOptions from './PageProductDetailCommerceOptions';

// Variant picker + add-to-cart. Required in every product layout and never
// hideable — a product page that can't be bought from is not a product page
// — but the merchant may move it anywhere in the stack.
//
// Deliberately thin: PageProductDetailCommerceOptions already owns option
// resolution, stock messaging and the cart dispatch, and takes nothing but
// the product.

export interface BlockProductBuyBoxData {
  heading?: string;
  ctaLabel?: string;
}

const useStyles = makeStyles((theme: Theme) =>
createStyles({
  root: {
    marginBottom: '28px',
    marginTop: '20px',
    position: 'relative',
  },
  heading: {
    fontWeight: 'bold',
    color: '#121212',
    fontSize: '14px',
    marginBottom: '6px',
  },
}),
);

// "Pilih varian" only makes sense when there is actually a variant matrix to
// work through. With one option the option's own label already says what to
// pick ("WARNA"), and with none there is nothing to pick at all — in both
// cases the heading just adds a layer of noise above a single choice.
export function defaultBuyBoxHeading(optionCount: number): string {
  return optionCount >= 2 ? 'PILIH VARIAN & BELI' : 'BELI PRODUK';
}

export default function BlockProductBuyBox({ content }: { content: BlockProductBuyBoxData }) {
  const classes = useStyles();
  const page = useContext(ProductPageContext);
  if (!page) return null;

  // An empty/absent heading means "decide from the product". A merchant who
  // typed their own copy always wins.
  const optionCount = page.product.commerce?.options?.length ?? 0;
  const heading = content?.heading || defaultBuyBoxHeading(optionCount);

  return (
    <Box className={classes.root} id="tb-product-buybox">
      {!!heading &&
        <Typography className={classes.heading}>{heading}</Typography>}
      <PageProductDetailCommerceOptions
        productDetail={page.product}
        ctaLabel={content?.ctaLabel || undefined} />
    </Box>
  );
}
